import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { ImpersonationBroker, asApiError } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { KEYWORD_PINS_TYPE, type KeywordPinView } from '../pins/serverTypes';
import { queryKeys } from './queryKeys';

export function useKeywordPinsQuery(): UseQueryResult<KeywordPinView[], Error> {
	const userSession = useUserSession();

	return useQuery<KeywordPinView[], Error>({
		queryKey: queryKeys.focusedView.keywordPins(),
		queryFn: async () => {
			const result = await userSession.webServiceHelper.callWebServiceAsync<KeywordPinView[]>(
				ImpersonationBroker.composeApiUrl({ urlPath: `user/coffee/customizations/${KEYWORD_PINS_TYPE}` }),
				'GET'
			);
			if (!result.success) {
				throw asApiError(result);
			}
			return result.value ?? [];
		},
		meta: { toastErrorMessage: 'Failed to load keyword pins' },
	});
}
